import { createAction, props } from '@ngrx/store';

export const NameNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Name Neverbounce Changed',
  props<{ nameNeverbounce: string }>(),
);

export const StatusNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Status Neverbounce Changed',
  props<{ statusNeverbounce: boolean }>(),
);

export const NotificationEmailNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Notification Email Neverbounce Changed',
  props<{ notificationEmailNeverbounce: string }>(),
);

export const JobMaxSizeNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Job Max Size Neverbounce Changed',
  props<{ jobMaxSizeNeverbounce: number | null }>(),
);

export const ResultTypeNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Result Type Neverbounce Changed',
  props<{ resultTypesNeverbounce: string[] }>(),
);

export const BaseUrlNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Base URL Neverbounce Changed',
  props<{ baseUrlNeverbounce: string }>(),
);

export const ReadTimeoutNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Read Timeout Neverbounce Changed',
  props<{ readTimeoutNeverbounce: number | null }>(),
);

export const ConnectionTimeoutNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Connection Timeout Neverbounce Changed',
  props<{ connectionTimeoutNeverbounce: number | null }>(),
);

export const ApiKeyNeverbounceChange = createAction(
  '[NEVERBOUNCE CONFIGURATION]: API Key Neverbounce Changed',
  props<{ apiKeyNeverbounce: string }>(),
);

export const SaveNeverbounceConfiguration = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Save Neverbounce Configuration',
);

export const SaveNeverbounceConfigurationSuccess = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Save Neverbounce Configuration Success',
  props<{ res: any }>(),
);

export const SaveNeverbounceConfigurationFailed = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Save Neverbounce Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateNeverbounceConfiguration = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Update Neverbounce Configuration',
);

export const UpdateNeverbounceConfigurationSuccess = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Update Neverbounce Configuration Success',
  props<{ res: any }>(),
);

export const UpdateNeverbounceConfigurationFailed = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Update Neverbounce Configuration Failed',
  props<{ error: any }>(),
);

export const ToggleRootConfHelpTextStatus = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Toggle Root Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const ToggleEndpointConfHelpTextStatus = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Toggle Endpoint Configuration Help Text Status',
);

export const EditNeverbounceIntegrationSystem = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Edit Neverbounce Integration System',
  props<{ neverbounceData: any }>(),
);

export const CloseNeverbounceEditIntegration = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Close Neverbounce Edit Integration',
);

export const NeverbounceSubmitData = createAction(
  '[NEVERBOUNCE CONFIGURATION]: Neverbounce Submit Data',
);
